import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FacadeService } from "src/app/shared/service-facade/facade.service";
import {ApplicationLogsRequest} from "leia-api";
import StatusEnum = ApplicationLogsRequest.StatusEnum;
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { IdleDialogComponent } from "src/app/shared/components/idle-dialog/idle-dialog.component";
import { AbandonReason } from "src/app/shared/model/abandon-reason";

@Injectable({
  providedIn: "root"
})
export class ApplicationIdleService {
  private _isApplicationAbandoned = false;
  get isApplicationAbandoned(): boolean {
    return this._isApplicationAbandoned;
  }

  private _dialogRef!: MatDialogRef<any>;

  constructor(
    private idle: Idle,
    private dialog: MatDialog,
    private facade: FacadeService
  ) {}

  initialize(): void {
    let idleTimeoutInSecondsAsString : string = this.facade.getStorageItem("idle-timeout-in-seconds");
    let idleTimeoutInSeconds: number = parseInt(idleTimeoutInSecondsAsString);

    let idleTimeoutUntilRedirectInSecondsAsString : string = this.facade.getStorageItem("idle-timeout-until-redirect-in-seconds");
    let idleTimeoutUntilRedirectInSeconds: number = parseInt(idleTimeoutUntilRedirectInSecondsAsString);

    this.idle.setIdle(idleTimeoutInSeconds);
    this.idle.setTimeout(idleTimeoutUntilRedirectInSeconds);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleStart.subscribe(() => {
      if (this.isApplicationInFinishedState() || this._isApplicationAbandoned) return;

      this._dialogRef = this.dialog.open(IdleDialogComponent, {
        width: "500px",
        position: {
          top: '20px'
        },
        disableClose: false,
        hasBackdrop: true
      });
    });

    this.idle.onIdleEnd.subscribe(() => {
      this.dialog.closeAll();
    });

    this.idle.onTimeout.subscribe(() => {
      if (this.isApplicationInFinishedState() || this.isApplicationAbandoned) return;

      this.facade.cleanupApplication(AbandonReason.Idle).then(value => {
        this.dialog.closeAll();
        this._isApplicationAbandoned = true;
      });
    });

    this.idle.watch();

  }

  isApplicationInFinishedState() : boolean {
    const applicationRequest = this.facade.getShoppingCartApplicationLogsRequest();

    if (applicationRequest.status === StatusEnum.Approved || applicationRequest.status === StatusEnum.Rejected || applicationRequest.status === StatusEnum.UnderReview) return true;

    return false;
  }

  markApplicationAsAbandoned(): void {
    this._isApplicationAbandoned = true;
  }
}
